import React from 'react';
import { StyledBodyContainer, StyledBody } from '../styled/Body.styled';

interface BodyProps {
    children: React.ReactElement;
}

const Body = (props: BodyProps) => {
    return (
        <StyledBodyContainer>
            <StyledBody>{props.children}</StyledBody>
        </StyledBodyContainer>
    );
};

export default Body;
